<div class="seed-return-add-prod">
  <div class="prod-top-sec">
    <h2 class="xs-pl-0">
      Add Early Advantage Product(s) to the order
    </h2>
  </div>

  <div class="col-12">
    <div class="row">
      <div class="col-12">
        <app-filter [(optionsData)]="filterOptionsData" [isSearchButtonOutside]="true" (searchClick)="filterSearchClick($event)" (clearAllClick)="filterClearAllClick($event)"></app-filter>
      </div>
    </div>
  </div>
  <div class="col-12 text-right margin-t15">

    <div class="d-inline-block margin-r15">Display Dealer Order Early Advantage Units</div>
    <mat-checkbox class="custom-checkbox align-top" [checked]="isDisplayDealerUnitsChecked" (change)="loadDealerToItems($event)"></mat-checkbox>
  </div>
  <div class="row margin-l0 margin-r0">
    <div id="orderView1" class="tableContainer">
      <table mat-table [(dataSource)]="eaAddProductDS" multiTemplateDataRows class="matTables">
        <ng-container matColumnDef="{{column}}" *ngFor="let column of displayColumns">
          <div *ngIf="column=='productName'"><th mat-header-cell *matHeaderCellDef class="productName text-left">Product Name</th>
    </div>
    <div *ngIf="column=='packageSize'"><th mat-header-cell *matHeaderCellDef class="packageSize text-center">Pack Size</th></div>
    <div *ngIf="column=='seedSize'"><th mat-header-cell *matHeaderCellDef class="seedSize text-center">Seed Size</th></div>
    <div *ngIf="column=='technology'"><th mat-header-cell *matHeaderCellDef class="treatment text-center">Technology</th></div>
    <div *ngIf="column=='treatment'"><th mat-header-cell *matHeaderCellDef class="treatment text-center">Treatment</th></div>
    <div *ngIf="column=='maturity'"><th mat-header-cell *matHeaderCellDef class="treatment text-center">Maturity</th></div>
    <div *ngIf="column=='productLine'"><th mat-header-cell *matHeaderCellDef class="treatment text-center">Product Line</th></div>
    <div *ngIf="column=='dealerUnits'"><th mat-header-cell *matHeaderCellDef class="availableUnit text-center">Dealer Units</th></div>
    <div *ngIf="column=='eaUnits'"><th mat-header-cell *matHeaderCellDef class="dealerUnit text-center">EA Units</th></div>
    <td mat-cell *matCellDef="let element">
      <div *ngIf="column=='productName'" class="order-info" [attr.data-testid]="'ea-' + element.itemNumber">
        <div class="row">
          <div class="col-md-11 padding-l5" matTooltip="{{element.brand}} - {{element.marketingBrand}} #{{element.itemNumber}}" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">
            <div class="d-block d-md-none">Product</div>
            <div class="bold">
              {{element.brand}} - {{element.marketingBrand}}
            </div>
            <div class="bold d-block updateFont">{{element.itemDescription}}</div>
          </div>
        </div>
      </div>

      <div *ngIf="column=='packageSize'" class="order-info text-center">
        <div class="row">
          <div class="col-md-11 padding-l15">
            <span matTooltip="{{element.packageSize}}" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">
              <strong>{{element.packageSize}}</strong>
            </span>
          </div>
        </div>
      </div>
      <div *ngIf="column=='seedSize'" class="order-info text-center">
        <div class="row">
          <div class="col-md-11 padding-l10">
            <div class="bold text-center">{{element.seedSize}}</div>
          </div>
        </div>
      </div>
      <div *ngIf="column=='technology'" class="order-info text-center">
        <div class="row">
          <div class="col-md-11 padding-l20">
            <span matTooltip="{{element.technology}}" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">
              <strong>{{element.technology}}</strong>
            </span>
          </div>
        </div>
      </div>
      <div *ngIf="column=='treatment'" class="order-info text-center">
        <div class="row">
          <div class="col-md-11 padding-l20">
            <span matTooltip="{{element.treatment}}" [matTooltipPosition]="'above'" matTooltipClass="whiteFontCpp">
              <strong>{{element.treatment}}</strong>
            </span>
          </div>
        </div>
      </div>

      <div *ngIf="column=='maturity'" class="order-info text-center">
        <div class="row">
          <div class="col-md-11 padding-l15">
            <span>
              <strong>{{element.maturity}}</strong>
            </span>
          </div>
        </div>
      </div>
      <div *ngIf="column=='productLine'" class="order-info text-center">
        <div class="row">
          <div class="col-md-11 padding-l20">
            <span>
              <strong>{{element.productLine}}</strong>
            </span>
          </div>
        </div>
      </div>
      <div *ngIf="column=='dealerUnits'" class="order-info text-center">
        <div class="row">
          <div class="col-md-11 padding-l15">
            <span>
              <strong>{{element.dealerUnits}}</strong>
            </span>
          </div>
        </div>
      </div>

      <div *ngIf="column=='eaUnits'">
        <div class="order-info defaultCursor padding-l15 margin-t-15">
          <div>
            <button class="plus-minus-btn minusBtn" (click)="dealerUnitChange('decrease',element);" [attr.data-testid]="'decrease-ea-' + element.itemNumber"> - </button>
            <input type="text" class="geu-txt" [(ngModel)]="element.eaUnits" (keypress)="keyPressNumbers($event)" maxlength="5" NumbersOnly (focusout)="validateLineItem(element)" [attr.data-testid]="'qty-ea-' + element.itemNumber"/>
            <button class="plus-minus-btn plusBtn" (click)="dealerUnitChange('increase',element);" [attr.data-testid]="'increase-ea-' + element.itemNumber"> + </button>
          </div>
        </div>
      </div>
    </td>
    </ng-container>
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayColumns.length">
        <div class="inline-error" *ngIf="element.lineErrors && element.lineErrors.errors.length > 0" id="error_{{element.lineErrors.rowId}}">
          <div class="row">
            <div class="col-md-9">
              <ol class="error-list">
                <li *ngFor="let err of element.lineErrors.errors">
                  {{err.error}}
                </li>
              </ol>
            </div>
            <div class="col-md-3 revertToPrev" (click)="revertToPreviousError(element, true)">
              <span>
                Revert to Previous.
                <i class="icon-ico-Reply"></i>
              </span>
            </div>
          </div>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayColumns;sticky:true;"></tr>
    <tr mat-row *matRowDef="let element; columns: displayColumns;"
        class="example-element-row"
        [class.example-expanded-row]="expandedElement === element"
        (click)="expandedElement = expandedElement === element ? null : element"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
    </table>
    <div *ngIf="eaAddProductDS == undefined || eaAddProductDS?.data.length == 0" class="noDataMsg">
      <p class="padding-b47">No Record Found.</p>
    </div>
  </div>
</div>
</div>
<!--Error section on table-->

<div class="tableTotalsSec">
  <div class="modifyEA common-error-block new-return-request" *ngIf="showErrorBlock && errorMsgs.length>0 && errorMsgs[index]?.errors?.length > 0">
    <div class="row">
      <div class="col-1 padding-r0 errCountOuter">
        <span class="errorCounting">
          {{currentErrorRow}} of {{errorMsgs.length}}
        </span>
      </div>
      <div class="col-7 padding-l0 ">
        <ul class="errorMsg">
          <li *ngFor="let err of errorMsgs[index].errors">
            <p class="padding-10"> {{err.error}}</p>
          </li>
        </ul>
      </div>
      <div class="col-4 button-sec text-right">
        <button mat-raised-button class="btns" color="primary" (click)="revertAllChanges()">Revert All Errors</button>
        <button mat-raised-button class="btns" color="primary" *ngIf="errorMsgs && errorMsgs.length>1" (click)="nextError()">Next Error</button>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-9">
      <button mat-raised-button class="btns" color="primary" (click)="updateOrder()" [disabled]="showHideUpdateBtn()">Update Order</button>
      <a class="pe-auto text-decoration-underline" style="cursor:pointer" (click)="onCancel()">Cancel </a>
    </div>
    <div class="col-3 text-right count">
      EA Units Added: <span> {{commonService.getFormatedNumber(totalEaUnits) | number}}</span>
    </div>
  </div>
</div>
